<template>
<div>
  <el-inline>
    <el-kpi margin-top margin-right margin-left
      :value="subscriberQuantity"
      caption="Subscribers"
      />

    <el-kpi margin-top margin-right
      :value="purchaseQuantity"
      caption="Total orders"
      />

    <el-kpi margin-top margin-right margin-left
      :value="revenue"
      unit="kr"
      caption="Total revenue"
      />

  </el-inline>

  <br><br>

  <h2>Orders</h2>
  <bar-graph
    :height="200"
    :data="monthlyRevenue"
    :options="{
      animation: false,
      color: ['#1181C2'],
      scales: {
        yAxes: [{
          ticks: {
            suggestedMin: 0
          },
          width: 10
        }]
      }
    }"
    />

  <el-multi-switch
    v-model="revenuePeriod"
    :options="[
      { value: 'week', label: 'Week' },
      { value: 'month', label: 'Month' }
    ]"
    />
  <el-multi-switch margin-top
    v-model="revenueQuantity"
    :options="[
      { value: 'quantity', label: 'Quantity' },
      { value: 'revenue', label: 'Revenue' }
    ]"
    />

  <br><br>
</div>
</template>
<script>
import { mapGetters } from 'vuex'
import BarGraph from './BarGraph.vue'

import groupCount from 'script/groupCount.js'

export default {
  components: { BarGraph },
  data () {
    return {
      revenuePeriod: 'week',
      revenueQuantity: 'quantity'
    }
  },
  computed: {
    ...mapGetters(['kpi']),
    subscriberQuantity () {
      return this.$store.getters.subscribers.length
    },
    purchaseQuantity () {
      return this.$store.getters.purchases.reduce((acc, order) => {
        const quantity = order.quantity || 1
        return acc + quantity
      }, 0)
    },
    revenue () {
      return this.$store.getters.purchases.reduce(
        (accumulator, purchase) => accumulator + purchase.total
        , 0
      ) // .toLocaleString('sv-SV', { style: 'currency', currency: 'SEK' })
    },
    monthlyRevenue () {
      let quantityPeriod = {}
      const orderQuantity = []
      const values = []
      const timestamps = this.$store.getters.purchases.map(order => {
        values.push(order.total)
        orderQuantity.push(order.quantity || 1)
        return order.timestamp
      })

      if (this.revenueQuantity === 'revenue') {
        quantityPeriod = this.revenuePeriod === 'week'
          ? groupCount.perWeek(timestamps, values)
          : groupCount.perMonth(timestamps, values)
      } else {
        quantityPeriod = this.revenuePeriod === 'week'
          ? groupCount.perWeek(timestamps, orderQuantity)
          : groupCount.perMonth(timestamps, orderQuantity)
      }
      const labels = []
      const quantities = []

      Object.entries(quantityPeriod).forEach(([weekNumber, quantity]) => {
        labels.push(weekNumber.substring(4, 6))
        quantities.push(quantity)
      })

      return {
        labels: labels,
        datasets: [{
          label: 'Orders',
          backgroundColor: '#f87979',
          data: quantities
        }]
      }
    }
  },
  methods: {
    toPercentage (value) {
      let p = String(Math.round(value * 1000) / 10)
      p = p.indexOf('.') === -1 ? p + '.0' : p

      return p + ' %'
    }
  }
}
</script>
